import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Modal} from 'semantic-ui-react';

import * as Analytics from '../../services/analytics';
import {ReportViewRef} from '../../state/reports/types';
import * as ViewActions from '../../state/views/actions';
import {useViewRefAction} from '../../state/views/hooks';
import {LoadableView} from '../../state/views/types';
import {imgSrcWithDefault} from '../../util/images';
import EditableImage from '../EditableImage';

type SetPreviewImageModalProps = {
  view: LoadableView;
  reportViewRef: ReportViewRef;
  isPublicProject: boolean;
  isModalOpen: boolean;
  handleOnClose: () => void;
};

export const SetPreviewImageModal = ({
  view,
  reportViewRef,
  isModalOpen,
  isPublicProject,
  handleOnClose,
}: SetPreviewImageModalProps) => {
  const setUrl = useViewRefAction(reportViewRef, ViewActions.setPreviewUrl);

  return (
    <Modal open={isModalOpen} onClose={handleOnClose} size="small">
      <Modal.Header>Set Preview Image</Modal.Header>
      <Modal.Content>
        <EditableImage
          label={false}
          displaySize={400}
          photoUrl={imgSrcWithDefault(view.previewUrl)}
          viewID={view.id}
          save={newVal => {
            setUrl(newVal);
            Analytics.reportSetPreviewImageSaved({
              isPublicProject,
            });
          }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleOnClose}>Save</Button>
      </Modal.Actions>
    </Modal>
  );
};
